export const formatarValorMoeda = (valor: string): string => {
  return valor
    .replace('R$', '')
    .replace(' ', '')
    .replace(/&nbsp;/gi, '')
    .replaceAll('.', '')
    .replace(',', '.')
}
